import { storableError } from '../../util/errors';
import * as log from '../../util/log';
import { fetchCurrentUser, fetchStripeSubscription } from '../../ducks/user.duck';
import { createStripeSubscription, cancelSubscription, getAvailablePlans } from '../../ducks/stripe.duck';
import { setInitialValues as setInitialValuesForPaymentMethods } from '../../ducks/paymentMethods.duck';

// ================ Action types ================ //

export const SETUP_INTENT_REQUEST = 'app/PaymentMethodsPage/SETUP_INTENT_REQUEST';
export const SETUP_INTENT_SUCCESS = 'app/PaymentMethodsPage/SETUP_INTENT_SUCCESS';
export const SETUP_INTENT_ERROR = 'app/PaymentMethodsPage/SETUP_INTENT_ERROR';

export const STRIPE_CUSTOMER_REQUEST = 'app/PaymentMethodsPage/STRIPE_CUSTOMER_REQUEST';
export const STRIPE_CUSTOMER_SUCCESS = 'app/PaymentMethodsPage/STRIPE_CUSTOMER_SUCCESS';
export const STRIPE_CUSTOMER_ERROR = 'app/PaymentMethodsPage/STRIPE_CUSTOMER_ERROR';

export const SET_PURCHASED = 'app/PaymentMethodsPage/SET_PURCHASED';
export const SET_PURCHASED_ERROR = 'app/PaymentMethodsPage/SET_PURCHASED_ERROR';

// ================ Reducer ================ //

const initialState = {
  setupIntentInProgress: false,
  setupIntentError: null,
  setupIntent: null,
  stripeCustomerFetched: false,
  purchased: false,
  purchasedError: null,
};

export default function payoutMethodsPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SETUP_INTENT_REQUEST:
      return { ...state, setupIntentInProgress: true, setupIntentError: null };
    case SETUP_INTENT_SUCCESS:
      return {
        ...state,
        setupIntentInProgress: false,
        setupIntentError: null,
        setupIntent: payload,
      };
    case SETUP_INTENT_ERROR:
      console.error(payload); // eslint-disable-line no-console
      return { ...state, setupIntentInProgress: false, setupIntentError: null };
    case STRIPE_CUSTOMER_REQUEST:
      return { ...state, stripeCustomerFetched: false };
    case STRIPE_CUSTOMER_SUCCESS:
      return { ...state, stripeCustomerFetched: true };
    case STRIPE_CUSTOMER_ERROR:
      console.error(payload); // eslint-disable-line no-console
      return { ...state, stripeCustomerFetchError: payload };
    case SET_PURCHASED:
      return { ...state, purchased: payload };
    case SET_PURCHASED_ERROR:
      return { ...state, purchasedError: payload };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const setupIntentRequest = () => ({ type: SETUP_INTENT_REQUEST });
export const setupIntentSuccess = () => ({ type: SETUP_INTENT_SUCCESS });
export const setupIntentError = e => ({
  type: SETUP_INTENT_ERROR,
  error: true,
  payload: e,
});

export const stripeCustomerRequest = () => ({ type: STRIPE_CUSTOMER_REQUEST });
export const stripeCustomerSuccess = () => ({ type: STRIPE_CUSTOMER_SUCCESS });
export const stripeCustomerError = e => ({
  type: STRIPE_CUSTOMER_ERROR,
  error: true,
  payload: e,
});
export const setPurchased = (payload) => ({ type: SET_PURCHASED, payload });
export const setPurchasedError = (payload) => ({ type: SET_PURCHASED_ERROR, payload });

// ================ Thunks ================ //

export const createStripeSetupIntent = () => (dispatch, getState, sdk) => {
  dispatch(setupIntentRequest());
  return sdk.stripeSetupIntents
    .create()
    .then(response => {
      const setupIntent = response.data.data;
      dispatch(setupIntentSuccess(setupIntent));
      return setupIntent;
    })
    .catch(e => {
      const error = storableError(e);
      log.error(error, 'create-setup-intent-failed');
      dispatch(setupIntentError(error));
      return { createStripeSetupIntentSuccess: false };
    });
};

export const acceptPurchased = () => (dispatch) => {
  dispatch(setPurchased(false));
};

export const createSubscription = params => (dispatch, getState, sdk) => {
  return dispatch(createStripeSubscription(params))
    .then(response => {
      dispatch(setPurchased(true));
      let stripeCustomerId = response?.subscription?.customer;

      if (stripeCustomerId) {
        sdk.currentUser.updateProfile({
          publicData: { stripeCustomerId }
        }).then(res => {}).catch(res => {
          console.log('User can not be updated', res);
        });
      }

      dispatch(fetchStripeSubscription());
    }).catch(e => {
      dispatch(fetchStripeSubscription());
    });
};

export const cancelSubscriptionManager = subscription => (dispatch, getState) => {
  return dispatch(cancelSubscription(subscription))
    .then(response => {
      dispatch(fetchStripeSubscription());
    });
};

export const stripeCustomer = () => (dispatch, getState, sdk) => {
  dispatch(stripeCustomerRequest());
  dispatch(getAvailablePlans());
  const fetchCurrentUserOptions = {
    callParams: { include: ['stripeAccount', 'stripeCustomer', 'stripeCustomer.defaultPaymentMethod'] },
    updateHasListings: false,
    updateNotifications: false,
    enforce: true,
  };

  return dispatch(fetchCurrentUser(fetchCurrentUserOptions))
    .then(response => {
      dispatch(stripeCustomerSuccess());
      dispatch(fetchStripeSubscription());
    })
    .catch(e => {
      const error = storableError(e);
      log.error(error, 'fetch-stripe-customer-failed');
      dispatch(stripeCustomerError(error));
    });
};

export const loadData = () => (dispatch, getState, sdk) => {
  dispatch(setInitialValuesForPaymentMethods());

  return dispatch(stripeCustomer());
};
